enum INITIALS {
  ExpirationMonth = 'MM',
  ExpirationYear = 'AA',
}

export default INITIALS;
